import { render, staticRenderFns } from "./ServiceInfo.vue?vue&type=template&id=13c72216&"
import script from "./ServiceInfo.vue?vue&type=script&lang=ts&"
export * from "./ServiceInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports